module.exports = __webpack_public_path__ + "img/base-rocket.43ec06c7.png";